import { useMemo } from 'react'
import { useIntl } from 'react-intl'
import GlobalSearchContextProvider from 'contexts/GlobalSearch/GlobalSearchContextProvider'
import HotelsTabContent from 'components/SearchV2/Components/Mobile/TabContents/HotelsTabContent'
import ModalBase from 'LuxKit/Modal/ModalBase'
import ModalHeader from 'LuxKit/Modal/ModalHeader'
import ModalBody from 'LuxKit/Modal/ModalBody'
import ModalContent from 'LuxKit/Modal/ModalContent'
import ModalFooter from 'LuxKit/Modal/ModalFooter'
import useListingDrawerMobileHotelSearch, { type ListingDrawerMobileHotelSearchParams } from '../hooks/useListingDrawerMobileHotelSearch'

interface Props extends ListingDrawerMobileHotelSearchParams {
  searchCalendarFocusDate?: Date
}

function ListingDrawerMobileHotelSearch(props: Props) {
  const { maxGuests, searchCalendarFocusDate, onClose } = props
  const { state, dispatch, canSearch, submit, temporarySearchSubmitRef } = useListingDrawerMobileHotelSearch(props)
  const intl = useIntl()
  const title = intl.formatMessage({
    id: 'oFZcQsgasUZh-Jng4CyJ',
    defaultMessage: 'Search hotels',
    description: 'Title for the hotel-only mobile search editor in the Trip Planner results drawer',
  })
  const searchLabel = intl.formatMessage({
    id: '1zUkebUnbrWeXs3XAXZU',
    defaultMessage: 'Search',
    description: 'Search button label in the mobile search modal footer',
  })
  const primaryActionProps = useMemo(() => ({ children: searchLabel, onClick: submit, disabled: !canSearch }), [canSearch, searchLabel, submit])

  return (
    <GlobalSearchContextProvider state={state} dispatch={dispatch}>
      <ModalBase mode="drawer" isOpen onClose={onClose}>
        <ModalHeader title={title} onCloseButtonClick={onClose} />
        <ModalBody>
          <ModalContent flushListItems>
            <HotelsTabContent focusMonth={searchCalendarFocusDate} isInPage onSearch={submit} closeSearch={onClose} maxGuests={maxGuests} temporarySearchSubmitRef={temporarySearchSubmitRef} />
          </ModalContent>
        </ModalBody>
        <ModalFooter primaryActionProps={primaryActionProps} />
      </ModalBase>
    </GlobalSearchContextProvider>
  )
}

export default ListingDrawerMobileHotelSearch
